import { getGetApiChatBotDataGetQueryKey, useGetApiChatBotDataGet } from "@/API"
import { Box, Loader, Text } from "@mantine/core"
import { Link } from "@tanstack/react-router"

export function ChatBotDataLink(props: { workspaceId: string, chatBotDataId: string }) {
    const chatBotData = useGetApiChatBotDataGet({ workspaceId: props.workspaceId, id: props.chatBotDataId }, {
        query: {
            queryKey: getGetApiChatBotDataGetQueryKey({ workspaceId: props.workspaceId, id: props.chatBotDataId }),
            enabled: !!props.workspaceId && !!props.chatBotDataId
        }
    })

    return <>
        {props.chatBotDataId ? <Box className="no-underline">
            {chatBotData.isFetching ? <Loader /> : chatBotData.isSuccess ? <Link to="/workspace/$workspaceId/chatBotData/$chatBotDataId" params={{
                workspaceId: props.workspaceId ?? "",
                chatBotDataId: props.chatBotDataId ?? ""
            }}>
                <Text c="var(--mantine-primary-color-filled)">
                    {chatBotData.data?.data.name}
                </Text>
            </Link> : <Text c="red">
                資料獲取失敗
            </Text>}
        </Box> : <Text c="gray">未連接</Text>}
    </>
}